@if (!isLoading && !endpoints?.length) {
<div class="no-data">
  <img src="assets/images/no_data_found.png" alt="No Data Found" class="mb-4" />
  <div class="no-data">{{ 'FEATURES.ENDPOINTS.NO_DATA_FOUND' | transloco }}</div>
</div>
} @else {
<section class="card">
  <h3 class="card__title">{{ 'FEATURES.ENDPOINTS.TITLE' | transloco }}</h3>

  <div class="table">
    <div class="table__head">
      <div class="col col--name">{{ 'FEATURES.ENDPOINTS.SERVICE_TARGET' | transloco }}</div>
      <div class="col col--url">{{ 'FEATURES.ENDPOINTS.ENDPOINT_URL' | transloco }}</div>
      <div class="col col--desc">{{ 'FEATURES.ENDPOINTS.DESCRIPTION' | transloco }}</div>
      <div class="col col--action">{{ 'FEATURES.ENDPOINTS.ACTION' | transloco }}</div>
    </div>


    @if (isLoading) {
    @for (r of skeletonRows; track r) {
    <div class="table__row">
      <div class="col col--name"><span class="skeleton"></span></div>
      <div class="col col--url"><span class="skeleton"></span></div>
      <div class="col col--desc"><span class="skeleton"></span></div>
      <div class="col col--action"></div>
    </div>
    }
    } @else {
    @for (ep of endpoints; track ep.name) {
    <div class="table__row">
      <div class="col col--name">
        <span class="name">{{ ep.name }}</span>
      </div>
      <div class="col col--url">{{ ep.url }}</div>
      <div class="col col--desc">{{ ep.description || '-' }}</div>
      <div class="col col--action">
        <div class="copy-btn" role="button" tabindex="0" (click)="onCopyId(ep.url)" (keydown.enter)="onCopyId(ep.url)">
          <mat-icon [svgIcon]="copiedUrl === ep.url ? 'check' : 'content_copy'" class="copy-btn__icon"></mat-icon>
          <span>{{ copiedUrl === ep.url ? 'Copied' : 'Copy' }}</span>
        </div>
      </div>
    </div>
    }
    }
  </div> 
</section>
}